import axios from 'axios'
import apiDefaultConfig from '../apiDefaultConfig'

const anonymousTokenKey = 'anonymousSessionToken'
const anonymousExpirationKey = 'anonymousSessionTokenExpiration'
const anonymousClient = axios.create()
let anonymousLoginPromise: Promise<string | null> | null = null

function expirationFromJwt(token: string) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.exp ? new Date(payload.exp * 1000).toISOString() : null
  } catch {
    return null
  }
}

function tokenIsValid(token: string | null, expiration: string | null) {
  return Boolean(token && expiration && !Number.isNaN(new Date(expiration).getTime()) && new Date(expiration) > new Date())
}

export function getToken() {
  const token = localStorage.getItem('sessionToken')
  return token && token !== 'undefined' ? token : null
}

export function clearUserSession() {
  localStorage.removeItem('userData')
  localStorage.removeItem('sessionToken')
  localStorage.removeItem('sessionTokenexpiration')
  localStorage.removeItem('sessionAnonymous')
}

export function getAnonymousToken() {
  return localStorage.getItem(anonymousTokenKey)
}

export function clearAnonymousSession() {
  localStorage.removeItem(anonymousTokenKey)
  localStorage.removeItem(anonymousExpirationKey)
}

export function GetAnonymousToken(force = false): Promise<string | null> {
  const token = getAnonymousToken()
  const expiration = localStorage.getItem(anonymousExpirationKey)

  if (!force && tokenIsValid(token, expiration)) return Promise.resolve(token)
  if (anonymousLoginPromise) return anonymousLoginPromise

  const timestamp = Date.now().toString()
  anonymousLoginPromise = anonymousClient
    .post(apiDefaultConfig.baseURL + '/Autenticacao/v1/Auth', {
      usuario: timestamp,
      senha: timestamp,
      Anonymous: true,
      token: '6e4a0edd4efb0f8e87d86e9b1a0419f1'
    })
    .then(response => {
      const accessToken = response?.data?.object?.token?.accessToken
      if (!accessToken) return null

      const tokenExpiration = expirationFromJwt(accessToken)
      localStorage.setItem(anonymousTokenKey, accessToken)
      if (tokenExpiration) localStorage.setItem(anonymousExpirationKey, tokenExpiration)
      return accessToken
    })
    .finally(() => {
      anonymousLoginPromise = null
    })

  return anonymousLoginPromise
}